/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  FormControlLabel,
  Button,
  RadioGroup,
  Radio,
  TextField,
  CircularProgress,
} from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import * as Yup from 'yup'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import Stack from '@mui/material/Stack'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import ReactTooltip from 'react-tooltip'
import '../../../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import WarningIcon from '@mui/icons-material/Warning'
import Table61 from '../../Tables/TablesSec6/Table61'
import { useAuthentication } from '../../../../../context/authenticationContext'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'

// eslint-disable-next-line no-unused-vars
import {
  InsertHasAnActionPlan,
  saveDrafElegibilityForm,
  saveElegibilityForm,
  UploadReportElegibility,
} from '../../../../../services/Elegibilidad/create'
import { UpdateEnviromentalManagementPlan } from '../../../../../services/Elegibilidad/put'
import { useEligibility } from '../../../../../context/EligibilityContext'
import {
  validateSubmitForm,
  getManagementPlanList,
  getCurrency,
  getIfiActionPlan,
  getReportWithoutPlan,
  getReportWithPlan,
} from '../../../../../services/Elegibilidad/get'
import ROUTES from '../../../../../routers/routes'
import { validateEditForm } from '../../../../../services/Forms/create'

const ElegibilidadSec6Edit = (props) => {
  const { goToStep } = props
  const history = useHistory()
  const { userIDB2C, userName, IdIFIToken } = useAuthentication()
  // eslint-disable-next-line no-unused-vars
  const [state, dispatch] = useEligibility()
  const { idElegibilityForm, editFormElegibility, setEditFormElegibility } =
    useFormElegibilidad()

  // eslint-disable-next-line no-unused-vars
  const [loadingSave, setLoadingSave] = useState(false)
  const [loading, setLoading] = useState(false)
  const [ready, setReady] = useState(false)
  const [allowSend, setAllowSend] = useState(false)
  const [actionPlan, setActionPlan] = useState(true)
  const [warning, setWarning] = useState(false)

  // eslint-disable-next-line no-unused-vars

  useEffect(() => {
    // let mounted = true
    if (state.step === 6 && !formik.values.Ready) {
      try {
        getManagementPlanList(editFormElegibility.IdElegibilityAnswer).then(
          (response) => {
            if (response.Success) {
              const data = response.Data
              // if (mounted) {
              formik.setValues({
                Acc1: data[0].IsCheck,
                Acc2: data[1].IsCheck,
                Acc3: data[2].IsCheck,
                Acc4: data[3].IsCheck,
                Acc5: data[4].IsCheck,
                Acc6: data[5].IsCheck,
                Acc7: data[6].IsCheck,
                Acc8: data[7].IsCheck,
                Acc9: data[8].IsCheck,
                Acc10: data[9].IsCheck,
                Acc11: data[10].IsCheck,
                Acc12: data[11].IsCheck,
                Acc13: data[12].IsCheck,
                Acc14: data[13].IsCheck,
                Acc15: data[14].IsCheck,
                Acc16: data[15].IsCheck,
                Ready: true,
              })
              // }
            }
          },
        )

        validateSubmitForm({
          userIDB2C,
          idForm: editFormElegibility.IdElegibilityAnswer,
        }).then((response) => {
          if (response.Success) {
            setAllowSend(response.Data)
          } else {
            console.log(response.Message)
          }
        })
      } catch (error) {
        console.log(error.message)
      }
    }

    // return () => {
    //   mounted = false
    // }
  }, [state.step])

  const enviromentalImpactText = {
    Acc1: '1.- ¿Su proyecto contamina el aire?',
    Acc2: '2.- ¿Su proyecto incrementa los niveles de ruido?',
    Acc3: '3.- ¿Su proyecto genera malos olores?',
    Acc4: '4.- ¿Su proyecto contamina el agua por falta de saneamiento básico?',
    Acc5: '5.- ¿Su proyecto disminuye el recurso del agua?',
    Acc6: '6.- Con el desarrollo del proyecto, ¿hará sedimentación de cursos de agua?',
    Acc7: '7.- ¿Su proyecto provoca contaminación por derrames de combustibles o lubricantes?',
    Acc8: '8.- ¿Con el proyecto se perderá capa orgánica? (pérdida de las capas u horizontes superiores de suelo, que contienen materia orgánica y nutriente, y que reducen el rendimiento de las cosechas en los suelos degradados.)',
    Acc9: '9.- ¿Con su proyecto se provocará erosión y sedimentación en el suelo?',
    Acc10:
      '10.- ¿Con su proyecto habrá pérdida de los recursos biológicos, incluyen los recursos madereros, acuáticos y recursos animales y vegetales (como ganado, huertos, cultivos y animales silvestres), hongos y bacterias?',
    Acc11:
      '11.- ¿Con su proyecto habrá daños o pérdidas al patrimonio cultural, que pueden incluir cualquier número de materiales, objetos o sitios que sean considerados de gran importancia cultural o histórica para las personas?',
    Acc12:
      '12.- ¿Con su proyecto habrá efectos en la salud de las personas por accidentes laborales o eventos naturales?',
    Acc13:
      '13.- ¿Con su proyecto se provocará efectos en la salud de las personas y proliferación de vectores y roedores por la presencia inadecuada de residuos (sólidos, líquidos y/o gaseosos)?',
    Acc14:
      '14.- ¿Con su proyecto se provocará efectos en la salud de las personas por presencia inadecuada de residuos líquidos (aguas residuales), potenciales de contaminación?',
    Acc15:
      '15.- ¿Considera que con su proyecto podría provocar ineficiencia en el consumo de energía?',
    Acc16:
      '16.- ¿Considera que con su proyecto habrá riesgo de exposición de sustancias peligrosas por parte de los empleados / asociados?',
  }

  const EnviromentalPlanSchema = Yup.object().shape({
    Acc1: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc2: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc3: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc4: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc5: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc6: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc7: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc8: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc9: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc10: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc11: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc12: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc13: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc14: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc15: Yup.boolean().nullable().required('Este campo es obligatorio'),
    Acc16: Yup.boolean().nullable().required('Este campo es obligatorio'),
    validateTable1: Yup.boolean().when('Acc1', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),
    validateTable2: Yup.boolean().when('Acc2', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),
    validateTable3: Yup.boolean().when('Acc3', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),
    validateTable4: Yup.boolean().when('Acc4', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable5: Yup.boolean().when('Acc5', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable6: Yup.boolean().when('Acc6', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable7: Yup.boolean().when('Acc7', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable8: Yup.boolean().when('Acc8', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable9: Yup.boolean().when('Acc9', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable10: Yup.boolean().when('Acc10', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable11: Yup.boolean().when('Acc11', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable12: Yup.boolean().when('Acc12', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable13: Yup.boolean().when('Acc13', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable14: Yup.boolean().when('Acc14', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable15: Yup.boolean().when('Acc15', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    validateTable16: Yup.boolean().when('Acc16', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),

    // validateTable1: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable2: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable3: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable4: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable5: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable6: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable7: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable8: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable9: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable10: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable11: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable12: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable13: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable14: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable15: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validateTable16: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      Acc1: null,
      Acc2: null,
      Acc3: null,
      Acc4: null,
      Acc5: null,
      Acc6: null,
      Acc7: null,
      Acc8: null,
      Acc9: null,
      Acc10: null,
      Acc11: null,
      Acc12: null,
      Acc13: null,
      Acc14: null,
      Acc15: null,
      Acc16: null,
      Ready: false,
      validateTable1: true,
      validateTable2: true,
      validateTable3: true,
      validateTable4: true,
      validateTable5: true,
      validateTable6: true,
      validateTable7: true,
      validateTable8: true,
      validateTable9: true,
      validateTable10: true,
      validateTable11: true,
      validateTable12: true,
      validateTable13: true,
      validateTable14: true,
      validateTable15: true,
      validateTable16: true,
    },
    validationSchema: actionPlan ? '' : EnviromentalPlanSchema,
  })

  const ResponsibleSchema = Yup.object().shape({
    // ActionPlanManager: Yup.string().required('Este campo es obligatorio'),
    // UserFullName: Yup.string().required('Este campo es obligatorio'),
  })

  const formHelper = useFormik({
    initialValues: {
      ActionPlanManager: editFormElegibility.ActionPlanManager || '',
      UserFullName: editFormElegibility.UserFullName || '',
    },
    validationSchema: actionPlan ? '' : ResponsibleSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  // Funcion para el cambio de la moneda
  const handleCurrency = async () => {
    let currency
    switch (editFormElegibility.IdCurrencyUser) {
      case 1:
        currency = 'HNL'
        break
      case 2:
        currency = 'NIC'
        break
      case 3:
        currency = 'DOM'
        break
      case 4:
        currency = 'CRC'
        break
      case 5:
        currency = 'GTQ'
        break
      case 6:
        currency = 'DOP'
        break
    }

    const dataCurrency = {
      SourceCurrencyCode: 'USD',
      TargetCurrencyCode: currency,
      OriginalAmount: 1,
    }

    if (editFormElegibility.IdCurrencyUser !== 3) {
      try {
        const response = await getCurrency(dataCurrency)
        if (response.error === null) {
          const Exchange =
            response.result
              .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
              .currencyExchange.resultingAmount

          formHelper.setFieldValue(
            'UserCurrencyToDollarExchangeRate',
            Number(Exchange),
          )
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  useEffect(() => {
    if (
      state.step === 6 &&
      editFormElegibility.IdCurrencyUser !== undefined &&
      editFormElegibility.IdCurrencyUser !== null
    ) {
      handleCurrency()
    }
  }, [state.step])

  const saveForm = async (values, borrador, exit) => {
    console.log('los values: ', values)
    setLoading(true)
    try {
      let object = {
        ...editFormElegibility,
        ...values,
      }
      if (!borrador) {
        object = {
          ...object,
          Draft: false,
          IdFormAction: 19,
          ENumber: null,
        }
      } else {
        if (editFormElegibility.IdElegibilityAnswer !== 0) {
          object = {
            ...object,
            Draft: true,
            IdFormAction: 24,
          }
        } else {
          object = {
            ...object,
            Draft: true,
            IdFormAction: 16,
          }
        }
      }
      const response = await saveDrafElegibilityForm({
        ...object,
      })

      if (response.Success) {
        // No es necesario guardar al contexto si nos salimos del componente
        // saveToContext(object)
        if (borrador) {
          setLoading(false)
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })
          if (exit) {
            history.push(ROUTES.IFIBORRADOR.pathname)
          }
        } else {
          getPDF(response.Data.IdElegibilityAnswer, response.Data.IdFormHistory)
          // if (actionPlan) {
          //   // swal({
          //   //   title: 'Formulario Enviado Exitosamente',
          //   //   icon: 'success',
          //   //   button: 'Entendido',
          //   // })
          //   // history.push('/')
          //   uploadReport(
          //     response.Data.IdElegibilityAnswer,
          //     response.Data.IdFormHistory,
          //   )
          // } else
          //   getPDF(
          //     response.Data.IdElegibilityAnswer,
          //     response.Data.IdFormHistory,
          //   )
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const validateFormStatus = async () => {
    let valido = false
    setLoading(true)

    const [accValidationErrors, responsibleValidationErrors] =
      await Promise.all([formik.validateForm(), formHelper.validateForm()])

    if (
      Object.keys(accValidationErrors).length > 0 ||
      Object.keys(responsibleValidationErrors).length > 0
    ) {
      valido = false
    } else {
      if (
        formik.values.Acc1 === false &&
        formik.values.Acc2 === false &&
        formik.values.Acc3 === false &&
        formik.values.Acc4 === false &&
        formik.values.Acc5 === false &&
        formik.values.Acc6 === false &&
        formik.values.Acc7 === false &&
        formik.values.Acc8 === false &&
        formik.values.Acc9 === false &&
        formik.values.Acc10 === false &&
        formik.values.Acc11 === false &&
        formik.values.Acc12 === false &&
        formik.values.Acc13 === false &&
        formik.values.Acc14 === false &&
        formik.values.Acc15 === false &&
        formik.values.Acc16 === false
      ) {
        setWarning(true)
        valido = false
      } else {
        setWarning(false)
        valido = true
      }
    }

    if (valido) {
      formHelper.submitForm()
      setReady(true)
    } else {
      alertValidationFields()
    }
    setLoading(false)
  }

  const valueDate = {
    someDate: new Date().toISOString().substring(0, 10),
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 5 })
    goToStep(5)
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const eviromentalManagementPlanUpdate = async (
    idEnvironmentalImpact,
    isCheck,
  ) => {
    try {
      const response = await UpdateEnviromentalManagementPlan({
        idElegibilityAnswer: idElegibilityForm,
        idEnvironmentalImpact: idEnvironmentalImpact,
        isChek: isCheck,
      })
      if (response.Success) {
        console.log('Actualizado Correctamente')
      } else {
        throw Error('Problema al Actualizar el estado')
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const toogleAcordion3 = useCallback((idAcordion, e) => {
    const value = e.currentTarget.value
    const check = 'Acc' + idAcordion
    try {
      if (value === 'si') {
        formik.setFieldValue(check, true, true)

        if (idElegibilityForm !== '' && idElegibilityForm !== 0) {
          eviromentalManagementPlanUpdate(idAcordion, true)
        } else {
          throw Error('No se pudo acceder al ID del formulario')
        }
      } else {
        formik.setFieldValue(check, false, true)
        // Actualizar en tabla el estado y eliminar los hijos
        if (idElegibilityForm !== '' && idElegibilityForm !== 0) {
          eviromentalManagementPlanUpdate(idAcordion, false)
        } else {
          throw Error('No se pudo acceder al ID del formulario')
        }
      }
    } catch (error) {
      console.log(error)
    }
  }, [])

  const getIfiPlan = async () => {
    try {
      const response = await getIfiActionPlan(editFormElegibility.IdIFI)
      if (response.Success) {
        setActionPlan(response.Data)
        HasAnActionPlan()
      } else {
        throw Error('Problema al obtener el plan de accion')
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const HasAnActionPlan = async () => {
    try {
      const response = await InsertHasAnActionPlan(
        editFormElegibility.IdElegibilityAnswer,
        actionPlan,
      )
      if (!response.Success) {
        console.log('error')
      } else {
        throw Error('Problema al obtener el plan de accion')
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (
      state.step === 6 &&
      editFormElegibility.IdIFI !== undefined &&
      editFormElegibility.IdIFI !== null
    ) {
      getIfiPlan()
    }
  }, [state.step])

  const cancelForm = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          editFormElegibility.IdElegibilityAnswer,
        )
        if (response.Success) {
          const exit = true
          saveForm(formHelper.values, true, exit)
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          editFormElegibility.IdElegibilityAnswer,
        )
        if (response.Success) history.push(ROUTES.IFIBORRADOR.pathname)
      }
    })
  }

  const getPDF = async (idForm, IdFormHistory) => {
    try {
      let response
      if (actionPlan)
        response = await getReportWithoutPlan(
          editFormElegibility.IdElegibilityAnswer,
        )
      else
        response = await getReportWithPlan(
          editFormElegibility.IdElegibilityAnswer,
        )
      if (response.Success) {
        const byteCharacters = atob(response.Data.Report)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = 'Formulario Elegibilidad'
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
        uploadReport(idForm, IdFormHistory)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const uploadReport = async (idForm, IdFormHistory) => {
    try {
      const bodyReport = {
        FileContents: '',
        FileExtension: 'pdf',
        FileName: `Formulario Elegibilidad ${idForm}`,
        Description: '',
        SizeMB: 0,
        IdForm: idForm,
        IdUser: userIDB2C,
        RelatedFormField: actionPlan ? 78 : 77,
        IdFormHistory: IdFormHistory,
      }

      const response = await UploadReportElegibility(bodyReport)
      if (response.Success) {
        swal({
          title: 'Formulario Enviado Exitosamente',
          icon: 'success',
          button: 'Entendido',
        })
        setLoading(false)
        history.push('/')
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => !loadingSave && saveForm(formHelper.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: !loadingSave ? '#5cb85c' : 'gray',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>
      <br></br>
      <form id="eligibility-sec-6" onSubmit={formik.handleSubmit}>
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">Plan de Gestión Ambiental y Social</h1>
          <br />
        </Grid>
        {actionPlan ? (
          <Grid item xs={12} sm={12} md={12}>
            <h4>
              <WarningIcon color="warning" fontSize="large" />
              La Institución Financiera Intermediaria cuenta con un Plan de
              Gestión Ambiental y Social
            </h4>
            <br />
          </Grid>
        ) : (
          <div>
            <WrapedAccordion
              formikTouched={formik.touched.Acc1}
              formikError={formik.errors.Acc1}
              acordionCheck={formik.values.Acc1}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={1}
              enviromentalImpactText={enviromentalImpactText.Acc1}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable1}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc2}
              formikError={formik.errors.Acc2}
              acordionCheck={formik.values.Acc2}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={2}
              enviromentalImpactText={enviromentalImpactText.Acc2}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable2}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc3}
              formikError={formik.errors.Acc3}
              acordionCheck={formik.values.Acc3}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={3}
              enviromentalImpactText={enviromentalImpactText.Acc3}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable3}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc4}
              formikError={formik.errors.Acc4}
              acordionCheck={formik.values.Acc4}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={4}
              enviromentalImpactText={enviromentalImpactText.Acc4}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable4}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc5}
              formikError={formik.errors.Acc5}
              acordionCheck={formik.values.Acc5}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={5}
              enviromentalImpactText={enviromentalImpactText.Acc5}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable5}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc6}
              formikError={formik.errors.Acc6}
              acordionCheck={formik.values.Acc6}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={6}
              enviromentalImpactText={enviromentalImpactText.Acc6}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable6}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc7}
              formikError={formik.errors.Acc7}
              acordionCheck={formik.values.Acc7}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={7}
              enviromentalImpactText={enviromentalImpactText.Acc7}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable7}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc8}
              formikError={formik.errors.Acc8}
              acordionCheck={formik.values.Acc8}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={8}
              enviromentalImpactText={enviromentalImpactText.Acc8}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable8}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc9}
              formikError={formik.errors.Acc9}
              acordionCheck={formik.values.Acc9}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={9}
              enviromentalImpactText={enviromentalImpactText.Acc9}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable9}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc10}
              formikError={formik.errors.Acc10}
              acordionCheck={formik.values.Acc10}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={10}
              enviromentalImpactText={enviromentalImpactText.Acc10}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable10}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc11}
              formikError={formik.errors.Acc11}
              acordionCheck={formik.values.Acc11}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={11}
              enviromentalImpactText={enviromentalImpactText.Acc11}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable11}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc12}
              formikError={formik.errors.Acc12}
              acordionCheck={formik.values.Acc12}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={12}
              enviromentalImpactText={enviromentalImpactText.Acc12}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable12}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc13}
              formikError={formik.errors.Acc13}
              acordionCheck={formik.values.Acc13}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={13}
              enviromentalImpactText={enviromentalImpactText.Acc13}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable13}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc14}
              formikError={formik.errors.Acc14}
              acordionCheck={formik.values.Acc14}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={14}
              enviromentalImpactText={enviromentalImpactText.Acc14}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable14}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc15}
              formikError={formik.errors.Acc15}
              acordionCheck={formik.values.Acc15}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={15}
              enviromentalImpactText={enviromentalImpactText.Acc15}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable15}
            />
            <WrapedAccordion
              formikTouched={formik.touched.Acc16}
              formikError={formik.errors.Acc16}
              acordionCheck={formik.values.Acc16}
              toogleAcordion3={toogleAcordion3}
              idEnviromentalImpact={16}
              enviromentalImpactText={enviromentalImpactText.Acc16}
              formikSetFielValues={formik.setFieldValue}
              formikErrorTable={formik.errors.validateTable16}
            />
            <Grid container spacing={1} className="input__container">
              {warning ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  Seleccione al menos una medida de mitigacion
                </div>
              ) : null}

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Responsable plan de acción
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="ActionPlanManager"
                    style={{ width: '100%' }}
                    error={formHelper.errors.ActionPlanManager}
                    variant="outlined"
                    inputProps={{ maxLength: 60 }}
                    onChange={(e) => {
                      console.log('tar', e.target.value)
                      formHelper.setFieldValue(
                        'ActionPlanManager',
                        e.target.value,
                      )
                    }}
                    value={formHelper.values.ActionPlanManager}
                  />
                  {formHelper.errors.ActionPlanManager ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formHelper.errors.ActionPlanManager}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          </div>
        )}

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              Usuario registra formulario
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FormControl style={{ width: '100%' }}>
              <TextField
                id="UserName"
                style={{ width: '100%' }}
                error={formHelper.errors.UserName}
                variant="outlined"
                disabled
                value={userName || ''}
              />
              {formHelper.errors.UserFullName ? (
                <div
                  style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                >
                  {formHelper.errors.UserFullName}
                </div>
              ) : null}
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">Fecha de presentación</label>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl style={{ width: '100%' }}>
              <Stack component="form" noValidate spacing={3}>
                <TextField
                  id="PresentationDate"
                  name="PresentationDate"
                  type="date"
                  variant="outlined"
                  defaultValue={valueDate.someDate}
                  sx={{ width: 220 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Stack>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  {allowSend ? (
                    loading ? (
                      <Button className="button__wizard button__next">
                        <CircularProgress size={23} color="secondary" />
                      </Button>
                    ) : (
                      <>
                        <Button
                          // type="submit"
                          onClick={() => validateFormStatus()}
                          className="button__wizard button__next"
                          // disabled={true}
                        >
                          Registrar Formulario
                        </Button>
                      </>
                    )
                  ) : (
                    <>
                      <Button
                        type="submit"
                        variant="contained"
                        className="button__wizard button__next"
                        disabled
                      >
                        Registrar
                      </Button>
                      <Grid
                        alignItems="center"
                        style={{
                          textAlign: 'center',
                          width: '41%',
                          marginTop: '10px',
                          backgroundColor: '#ffefcc',
                          borderRadius: 5,
                          padding: 10,
                          marginLeft: '54%',
                        }}
                      >
                        <WarningIcon
                          color="yellow"
                          style={{
                            color: '#FAAD14',
                            fontSize: '25px',
                          }}
                        />
                        <p style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Solo el creador del formulario puede registrarlo
                        </p>
                      </Grid>
                    </>
                  )}

                  {/* )} */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

const WrapedAccordion = React.memo((props) => {
  const {
    // formikTouched,
    formikError,
    acordionCheck,
    toogleAcordion3,
    idEnviromentalImpact,
    enviromentalImpactText,
    formikSetFielValues,
    formikErrorTable,
  } = props

  return (
    <>
      <Accordion
        id={'Acc' + idEnviromentalImpact}
        expanded={acordionCheck || false}
        defaultExpanded={false}
      >
        <AccordionSummary
          // expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Grid item xs={8} sm={8} md={8}>
            <Typography>{enviromentalImpactText}</Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <FormControl
              style={{
                width: '100%',
                marginTop: '0',
                paddingTop: '0',
                alignItems: 'center',
              }}
            >
              <RadioGroup
                id="1"
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                row
                value={
                  acordionCheck === null ? '' : acordionCheck ? 'si' : 'no'
                }
                onChange={(e) => toogleAcordion3(idEnviromentalImpact, e)}
              >
                <FormControlLabel value="si" control={<Radio />} label="Si" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              {formikError ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formikError}
                </div>
              ) : null}
            </FormControl>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={8} sm={8} md={8}></Grid>
          {acordionCheck && (
            <Table61
              idEnviromentalImpact={idEnviromentalImpact}
              formikSetFielValues={formikSetFielValues}
              acordionCheck={acordionCheck}
            />
          )}
          {formikErrorTable ? (
            <div
              style={{
                color: 'red',
                marginTop: '3px',
                fontSize: '13px',
              }}
            >
              {formikErrorTable}
            </div>
          ) : null}
        </AccordionDetails>
      </Accordion>
    </>
  )
})
WrapedAccordion.displayName = 'Accordion'

export default ElegibilidadSec6Edit
